<!-- ComponentIndexMovie -->

<template>
  <div
    style="
      display: flex;
      flex-direction: row;
      overflow-x: scroll;
      background-color: #ffffff;
      padding: 4px 0;
    "
  >
    <div
      v-for="(movie, index) of movieDataList"
      :key="index"
      style="
        display: block;
        margin: 0 4px;
        background-color: #ffffff;
        text-align: center;
      "
    >
      <van-image
        :src="movie.logo"
        fit="contain"
        height="160"
        lazy-load
        width="120"
      />
      <div
        class="van-ellipsis"
        style="width: 120px; font-size: 16px; margin-top: 8px"
      >
        {{ movie.name }}
      </div>
      <div
        style="
          display: flex;
          margin-top: 8px;
          justify-content: center;
          font-size: 12px;
        "
      >
        <van-tag style="font-size: 10px" type="warning"
          >{{ movie.rating }}分</van-tag
        >
        <van-tag
          v-if="movie.showmark"
          style="margin-left: 1px; font-size: 10px"
          text-color="#fff"
        >
          {{ movie.showmark }}
        </van-tag>
      </div>

      <div style="margin: 8px 0">
        <van-button
          size="mini"
          style="width: 60px; font-size: 14px"
          type="info"
          @click="toMovieDetail(movie.id, movie.name)"
        >
          购 票
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { api_get_hot_movie_list } from "@/api/goods-api";

export default {
  data() {
    return {
      movieDataList: [],
    };
  },

  mounted() {
    this.getMovieList();
  },

  methods: {
    toMovieDetail(id, name) {
      window.location.href =
        "/movie/cinema?movieId=" + id + "&movieName=" + name;
    },

    getMovieList() {
      api_get_hot_movie_list().then((res) => {
        budo_log.info("#416 getMovieList", res);
        this.movieDataList = res.data.movieList;
      });
    },
  },
};
</script>
